import { render } from "./WorkshopOrderSaleLoader.vue?vue&type=template&id=aeabef14"
import script from "./WorkshopOrderSaleLoader.vue?vue&type=script&lang=js"
export * from "./WorkshopOrderSaleLoader.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__